import { styled } from 'styled-components';

import React from 'react';

const Div = styled.div`
    color: ${(props) => props.theme.colorButtonPrimary};
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    text-decoration-line: none;
    padding: 10px 0;
    
    & a {
        text-decoration-line: none;
        
        &:hover {
            text-decoration-line: underline;
        }
    }
`;
const URL = ({ children }) => {
    return <Div>{children}</Div>;
};

export default URL;
